import React from "react";
import { Divider, Grid } from "@mui/material";

import MenuContacts from "../ContactsMenu";
import Platform from "./Platform";
import Products from "./Products/Products";

interface IProps {
  closeDropDown: () => void;
}

const SolutionsMenu: React.FC<IProps> = ({ closeDropDown }) => {
  return (
    <>
      <Grid
        container
        spacing={{ md: 3, lg: 6, xl: 10 }}
        mb={{ md: 3, lg: 4, xl: 8 }}
      >
        {/* Our platform */}
        <Grid item xs={6}>
          <Platform closeDropDown={closeDropDown} />
        </Grid>

        {/* Our Products */}
        <Grid item xs={6}>
          <Products closeDropDown={closeDropDown} />
        </Grid>
      </Grid>

      <Divider />
      <MenuContacts closeDropDown={closeDropDown} />
    </>
  );
};

export default SolutionsMenu;
